import { render, staticRenderFns } from "./DateFormat.vue?vue&type=template&id=978ce74a&scoped=true"
import script from "./DateFormat.vue?vue&type=script&lang=js"
export * from "./DateFormat.vue?vue&type=script&lang=js"
import style0 from "./DateFormat.vue?vue&type=style&index=0&id=978ce74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978ce74a",
  null
  
)

export default component.exports